// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"123":"8df95163","337":"48176645","522":"27b1b3e4","553":"54db6064","803":"a46ef772","848":"98d79aaf"}[chunkId] + ".css";
};